import { Injectable } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { BehaviorSubject, merge, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, share } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ResponsiveService {

    isDesktop = new BehaviorSubject(null);
    isMobile = new BehaviorSubject(null);
    mediaQueryChanged: Observable<any>;

    readonly breakpoints = {
        desktop: '(min-width: 768px)',
        mobile: '(max-width: 767.9px)',
    };

    constructor(private breakpointObserver: BreakpointObserver) {
        this.breakpointObserver.observe([this.breakpoints.desktop])
            .pipe(
                map(state => state.matches),
                distinctUntilChanged()
            )
            .subscribe(this.isDesktop);

        this.breakpointObserver.observe([this.breakpoints.mobile])
            .pipe(
                map(state => state.matches),
                distinctUntilChanged()
            )
            .subscribe(this.isMobile);
        this.mediaQueryChanged = merge(this.isDesktop,  this.isMobile)
            .pipe(
                debounceTime(10),
                share()
            );
    }

    get isDesktop$(): Observable<boolean> {
        return this.isDesktop.asObservable();
    }
}

